// eslint-disable-next-line
import React from 'react';

import '../css/sessionHeader.css';

import { AppContext } from '../AppContext';
import Text from '../basicComponents/Text';
import LogRecord from '../data/LogRecord';
import { RecordNavigation } from '../App';

export interface SessionHeaderProps {
	curRecord: LogRecord;
	recordNavigation: RecordNavigation;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SessionHeaderState {
}

export default class SessionHeader extends React.Component<SessionHeaderProps, SessionHeaderState> {

	// context
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	public render(): JSX.Element {

		return (
			<div className='session-header'>
				<i className={"session-header-navigation fas fa-angle-left"  + (this.props.recordNavigation.nextLeft()  !== undefined?  "" : " session-header-inactive")} data-name='left'  onClick={this.handleClick} ></i>
				<i className={"session-header-navigation fas fa-angle-right" + (this.props.recordNavigation.nextRight() !== undefined ? "" : " session-header-inactive")} data-name='right' onClick={this.handleClick} ></i>
				<Text className='session-header-value'>{this.props.curRecord.startDate}</Text>
				<Text className='session-header-value'>{this.props.curRecord.sessionId}</Text>
				<Text className='session-header-value'>{this.props.curRecord.callerId}</Text>
				<Text className='session-header-value'>{this.props.curRecord.cdpn}</Text>
				<Text className='session-header-value'>{this.props.curRecord.configName}</Text>
			</div>
		);

	}

	public handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
		
		const target = event.currentTarget;
		const name = target.dataset.name;

		console.log('clicked on ' + name);

		switch (name) {

			case 'left':
				{
					const nextRecord = this.props.recordNavigation.nextLeft();
					if (nextRecord && this.props.recordNavigation.moveToRecord) {
						this.props.recordNavigation.moveToRecord(nextRecord);
					}
				}
				break;

			case 'right':
				{
					const nextRecord = this.props.recordNavigation.nextRight();
					if (nextRecord && this.props.recordNavigation.moveToRecord) {
						this.props.recordNavigation.moveToRecord(nextRecord);
					}
				}
				break;

		}

	}

}